import { render } from "./SciDetailsPage.vue?vue&type=template&id=79e06dcc"
import script from "./SciDetailsPage.vue?vue&type=script&lang=js"
export * from "./SciDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__